import { inject, Injectable, signal } from '@angular/core';

import { LogService } from './log.service';

@Injectable({
  providedIn: 'root'
})
export class AudioUnlockService {
  private readonly logService = inject(LogService);
  private readonly unlocked = signal<boolean>(false);
  private readonly ctx = signal<AudioContext>(new AudioContext());

  unlock() {
    if (this.unlocked()) return;

    // Play 1 silent sample
    const buffer = this.ctx().createBuffer(1, 1, 22050);
    const source = this.ctx().createBufferSource();
    source.buffer = buffer;
    source.connect(this.ctx().destination);
    source.start(0);

    this.unlocked.set(true);
    this.logService.info('Audio unlocked');
  }

  isUnlocked() {
    return this.unlocked();
  }
}
